import iconMap from '@/language/es/utils/iconMap';

export default {
  iconMap,
};
